import { createContext, Dispatch, SetStateAction } from 'react';
import { Proposal } from 'ts/shared/interfaces/CreateProposalParams';
import { User } from 'ts/shared/interfaces/User';
import { defaultHotelBookS3, defaultUserSiteConfig } from '../constants/generic';
import { GlobalsConfig } from '../services/config';
import { InitSiteData } from 'ts/shared/interfaces/CmsPageResponse';

export type BookConfig = typeof defaultHotelBookS3;

export interface MainContextValue {
  proposal: Proposal;
  setProposal: Dispatch<SetStateAction<Proposal>>;
  user?: User;
  setUser: (user?: User) => void;
  setUserSiteConfig: (config: any) => void;
  userSiteConfig: any;
  loginAsUser?: User;
  setLoginAsUser: (user?: User) => void;
  globals?: GlobalsConfig;
  cdnUrl?: string;
  initSiteData?: InitSiteData;
  setInitSiteData: (data?: InitSiteData) => void;
  hideMyOrders?: boolean;
  showOrderCompanyId?: boolean;
  showOrderTripId?: boolean;
  isEnigma?: boolean;
  hideFlags?: boolean;
  bookConfig: BookConfig;
  discountHotelLimit?: boolean;
}

export const MainContext = createContext<MainContextValue>({
  proposal: {
    hotels: [],
    flights: [],
    dynamic: [],
    ilPackages: [],
    transfers: [],
  },
  setProposal: () => {},
  user: undefined,
  setUser: () => {},
  setUserSiteConfig: () => {},
  userSiteConfig: defaultUserSiteConfig,
  loginAsUser: undefined,
  setLoginAsUser: () => {},
  globals: undefined,
  setInitSiteData: () => {},
  bookConfig: defaultHotelBookS3,
});

export default MainContext;
